import TableIds from '../constants/tableIds';
import ModalIds from '../constants/modalIds';
import DrawerIds from '../constants/drawerIds';
import { getTableStore } from './table';
import { getModalStore } from './modal';
import { getEditClientFormStore } from './forms/editClient';
import { getCreateCompanyFormStore } from './forms/createCompany';
import { getEditCompanyFormStore } from './forms/editCompany';
import { getCreateUserFormStore } from './forms/createUser';
import { getEditUserFormStore } from './forms/editUser';
import { getCreateCalculationFormStore } from './forms/createCalculation';
import { getAuthStore } from './auth';
import { getCalculationDetailsStore } from './calculationDetails';
import { getDrawerStore } from './drawer';
import { getBalanceAccountsStore } from './balanceAccounts';
import { getCalculationStepDetailsStore } from './calculationStepDetails';
import { getAddDocumentsFormStore } from './forms/addDocuments';
import { getHistoricalModuleFormStore } from './forms/createHistoricalModule';
import { getCalculationReusableDocumentsStore } from './calculationReusableDocuments';
import { getDisplayHistoricalModuleStore } from './displayHistoricalModuleStore';
import { getServerErrorsStore } from './serverErrors';
import { getDisplayCompanyStore } from './displayCompanyStore';
import { getDisplayUserStore } from './displayUserStore';
import { getDocumentDetailsStore } from './documentDetailsStore';
import { getClientDetailsStore } from './clientDetailsStore';
import { getLegislationArticleStore } from './legislationArticleStore';
import { FilterIds } from '../constants/filters';
import { getAdminsTableFilterStore, getCalculationsTableFilterStore, getClientsTableFilterStore, getCompaniesTableFilterStore, getDocumentsTableFilterStore, getUsersTableFilterStore } from './filter';
const store = {
    table: {
        [TableIds.ADMINS]: getTableStore(),
        [TableIds.CLIENTS]: getTableStore(),
        [TableIds.COMPANIES]: getTableStore(),
        [TableIds.USERS]: getTableStore(),
        [TableIds.CALCULATIONS]: getTableStore(),
        [TableIds.DOCUMENTS]: getTableStore(),
        [TableIds.CLIENT_LOGS]: getTableStore(),
        [TableIds.CALCULATION_LOGS]: getTableStore(),
        [TableIds.NOTIFICATIONS]: getTableStore()
    },
    modal: {
        [ModalIds.CREATE_ADMIN]: getModalStore(),
        [ModalIds.DEACTIVATE_ADMIN_CONFIRM]: getModalStore(),
        [ModalIds.REACTIVATE_ADMIN_CONFIRM]: getModalStore(),
        [ModalIds.CREATE_CLIENT]: getModalStore(),
        [ModalIds.CREATE_COMPANY]: getModalStore(),
        [ModalIds.CREATE_USER]: getModalStore(),
        [ModalIds.EDIT_USER]: getModalStore(),
        [ModalIds.DISPLAY_USER]: getModalStore(),
        [ModalIds.EDIT_CLIENT]: getModalStore(),
        [ModalIds.EDIT_COMPANY]: getModalStore(),
        [ModalIds.DISPLAY_COMPANY]: getModalStore(),
        [ModalIds.CREATE_CALCULATION]: getModalStore(),
        [ModalIds.CREATE_CALCULATION_CONFIRM]: getModalStore(),
        [ModalIds.UPLOAD_BALANCE_ERROR]: getModalStore(),
        [ModalIds.ADD_DOCUMENTS]: getModalStore(),
        [ModalIds.ADD_COMMENTS]: getModalStore(),
        [ModalIds.CALCULATION_REUSABLE_DOCUMENTS]: getModalStore(),
        [ModalIds.CALCULATION_SEND_TO_VERIFIER]: getModalStore(),
        [ModalIds.CALCULATION_SEND_TO_APPROVER]: getModalStore(),
        [ModalIds.CALCULATION_REJECT]: getModalStore(),
        [ModalIds.CALCULATION_APPROVE]: getModalStore(),
        [ModalIds.CALCULATION_CLOSE_FOR_SUBMISSION_NON_UNIVERSAL_ROLE]: getModalStore(),
        [ModalIds.CALCULATION_CLOSE_FOR_SUBMISSION_UNIVERSAL_ROLE]: getModalStore(),
        [ModalIds.CALCULATION_REOPEN_NON_UNIVERSAL_ROLE]: getModalStore(),
        [ModalIds.CALCULATION_REOPEN_UNIVERSAL_ROLE]: getModalStore(),
        [ModalIds.CALCULATION_CONFIRM_SUBMISSION]: getModalStore(),
        [ModalIds.CALCULATION_APPROVE_REOPENING]: getModalStore(),
        [ModalIds.CALCULATION_REJECT_REOPENING]: getModalStore(),
        [ModalIds.CALCULATION_RECALL]: getModalStore(),
        [ModalIds.REPLACE_BALANCE_CONFIRM]: getModalStore(),
        [ModalIds.CALCULATION_TAKEN_OVER]: getModalStore(),
        [ModalIds.IDLE_USER]: getModalStore(),
        [ModalIds.LOGOUT_CONFIRM]: getModalStore(),
        [ModalIds.DELETE_DOCUMENT_CONFIRM]: getModalStore(),
        [ModalIds.DELETE_CALCULATION_CONFIRM]: getModalStore(),
        [ModalIds.DELETE_COMPANY_CONFIRM]: getModalStore(),
        [ModalIds.DELETE_CLIENT_CONFIRM]: getModalStore(),
        [ModalIds.DEACTIVATE_CLIENT_CONFIRM]: getModalStore(),
        [ModalIds.REACTIVATE_CLIENT_CONFIRM]: getModalStore(),
        [ModalIds.DEACTIVATE_OPERATIONS_CLIENT_CONFIRM]: getModalStore()
    },
    drawer: {
        [DrawerIds.BALANCE_ACCOUNTS]: getDrawerStore(),
        [DrawerIds.CALCULATION_DETAILS]: getDrawerStore(),
        [DrawerIds.DOCUMENT_DETAILS]: getDrawerStore(),
        [DrawerIds.CLIENT_DETAILS]: getDrawerStore(),
        [DrawerIds.LEGISLATION_ARTICLE]: getDrawerStore()
    },
    form: {
        editClient: getEditClientFormStore(),
        createCompany: getCreateCompanyFormStore(),
        editCompany: getEditCompanyFormStore(),
        createUser: getCreateUserFormStore(),
        editUser: getEditUserFormStore(),
        createCalculation: getCreateCalculationFormStore(),
        addDocuments: getAddDocumentsFormStore(),
        historicalModule: getHistoricalModuleFormStore()
    },
    filter: {
        [FilterIds.ADMINS]: getAdminsTableFilterStore(),
        [FilterIds.COMPANIES]: getCompaniesTableFilterStore(),
        [FilterIds.USERS]: getUsersTableFilterStore(),
        [FilterIds.CLIENTS]: getClientsTableFilterStore(),
        [FilterIds.DOCUMENTS]: getDocumentsTableFilterStore(),
        [FilterIds.CALCULATIONS]: getCalculationsTableFilterStore()
    },
    auth: getAuthStore(),
    serverErrors: getServerErrorsStore(),
    calculationDetails: getCalculationDetailsStore(),
    calculationStepDetails: getCalculationStepDetailsStore(),
    balanceAccounts: getBalanceAccountsStore(),
    calculationReusableDocuments: getCalculationReusableDocumentsStore(),
    displayHistoricalModule: getDisplayHistoricalModuleStore(),
    displayCompany: getDisplayCompanyStore(),
    displayUser: getDisplayUserStore(),
    documentDetails: getDocumentDetailsStore(),
    clientDetails: getClientDetailsStore(),
    legislationArticle: getLegislationArticleStore()
};
export default store;
